import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_LARGE } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import mq from '../../../styleUtility/mediaquery';

interface Props {
  proposal: boolean;
  className?: string;
}

const EmptyState: FC<Props> = ({ proposal, className }) => {
  return (
    <Root className={className}>
      <svg
        height="350"
        viewBox="0 0 320 350"
        width="320"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path id="a" d="m0 0h310v340h-310z" />
          <filter id="b" height="106.5%" width="106.5%" x="-3.2%" y="-2.1%">
            <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2.5" />
            <feColorMatrix
              in="shadowBlurOuter1"
              result="shadowMatrixOuter1"
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
            />
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter2" />
            <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation="1" />
            <feColorMatrix
              in="shadowBlurOuter2"
              result="shadowMatrixOuter2"
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0"
            />
            <feMorphology in="SourceAlpha" radius="1" result="shadowSpreadOuter3" />
            <feOffset dy="3" in="shadowSpreadOuter3" result="shadowOffsetOuter3" />
            <feGaussianBlur in="shadowOffsetOuter3" result="shadowBlurOuter3" stdDeviation=".5" />
            <feColorMatrix
              in="shadowBlurOuter3"
              result="shadowMatrixOuter3"
              values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0"
            />
            <feMerge>
              <feMergeNode in="shadowMatrixOuter1" />
              <feMergeNode in="shadowMatrixOuter2" />
              <feMergeNode in="shadowMatrixOuter3" />
            </feMerge>
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd" opacity=".4" transform="translate(5 4)">
          <use fill="#000" filter="url(#b)" xlinkHref="#a" />
          <use fill="#fff" xlinkHref="#a" />
          <g fill="#d3d3d3">
            <path d="m0 0h310v230h-310z" />
            <path d="m11 245h111v13h-111z" />
            <path d="m42 304h71v13h-71z" />
          </g>
          <g transform="translate(119 75)">
            <circle cx="36.5" cy="36.5" fill="#fff" r="36.5" />
            <path d="m40 19 17 34h-34z" fill="#d3d3d3" transform="matrix(0 1 -1 0 76 -4)" />
          </g>
          <circle cx="23.5" cy="310.5" fill="#d3d3d3" r="13.5" />
          <g transform="translate(11 297)">
            <path
              d="m12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
              fill="#fff"
              fillRule="nonzero"
            />
            <path d="m0 0h24v24h-24z" />
          </g>
        </g>
      </svg>
      <Text color="textSecondary" align="right">
        {proposal ? (
          <FormattedMessage id="show_project_page.tabs.proposal_empty_message" />
        ) : (
          <FormattedMessage id="show_project_page.tabs.deliverables_empty_message" />
        )}
      </Text>
    </Root>
  );
};

const Root = styled('div')(
  flexibleLayoutContainer({
    direction: 'row',
    wrap: 'wrap',
    alignItems: 'flex-start',
  }),
  {
    [mq('sp')]: {
      display: 'block',
      textAlign: 'center',
      '> p ': {
        marginLeft: 0,
        textAlign: 'center',
      },
    },
  },
);

const Text = styled(Typography)({
  marginTop: `${SPACING_LARGE}px`,
  marginLeft: `${SPACING_LARGE}px`,
  fontSize: 18,
});

export default EmptyState;
